/**
 * @flow
 * @relayHash cb801f189cf5b36ba7958f6e3d2b2652
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type MpTemplatePlaylistContainer_node$ref = any;
export type MpTemplatePlaylistContainer_RefetchQueryVariables = {|
  query: string,
  playlist_id: string,
|};
export type MpTemplatePlaylistContainer_RefetchQueryResponse = {|
  +node: ?{|
    +$fragmentRefs: MpTemplatePlaylistContainer_node$ref
  |}
|};
export type MpTemplatePlaylistContainer_RefetchQuery = {|
  variables: MpTemplatePlaylistContainer_RefetchQueryVariables,
  response: MpTemplatePlaylistContainer_RefetchQueryResponse,
|};
*/


/*
query MpTemplatePlaylistContainer_RefetchQuery(
  $query: String!
  $playlist_id: ID!
) {
  node(id: $playlist_id) {
    __typename
    ...MpTemplatePlaylistContainer_node_1Qr5xf
    id
  }
}

fragment MpTemplatePlaylistContainer_node_1Qr5xf on MpTemplatePlaylist {
  id
  title
  description
  max_length
  position
  thumbnail(width: 240, height: 240) {
    url
    width
    height
    id
  }
  playlist_recommendations {
    edges {
      node {
        id
        title
        description
        thumbnail(width: 240, height: 240) {
          url
          width
          height
          id
        }
        num_songs
      }
    }
  }
  playlist_songs: mp_template_playlist_songs(first: 99999) {
    edges {
      node {
        id
        position
        song {
          __typename
          id
          isrc
          name
          album
          artist
          song_images {
            edges {
              node {
                id
                url
                width
                height
              }
            }
          }
        }
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  song_search(first: 10, query: $query) {
    edges {
      node {
        __typename
        id
        name
        album
        artist
        isrc
        duration_ms
        song_images {
          edges {
            node {
              id
              url
              width
              height
            }
          }
        }
        ... on SpotifySong {
          external_id
          external_source
          external_data
        }
      }
    }
  }
  mp_template {
    can_edit
    public
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "query",
    "type": "String!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "playlist_id",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "playlist_id",
    "type": "ID!"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "__typename",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "description",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "position",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "url",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "width",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "height",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "thumbnail",
  "storageKey": "thumbnail(height:240,width:240)",
  "args": [
    {
      "kind": "Literal",
      "name": "height",
      "value": 240,
      "type": "Int"
    },
    {
      "kind": "Literal",
      "name": "width",
      "value": 240,
      "type": "Int"
    }
  ],
  "concreteType": "SongImage",
  "plural": false,
  "selections": [
    v7,
    v8,
    v9,
    v3
  ]
},
v11 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  }
],
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isrc",
  "args": null,
  "storageKey": null
},
v13 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v14 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "album",
  "args": null,
  "storageKey": null
},
v15 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "artist",
  "args": null,
  "storageKey": null
},
v16 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "song_images",
  "storageKey": null,
  "args": null,
  "concreteType": "SongImageConnection",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "SongImageEdge",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "SongImage",
          "plural": false,
          "selections": [
            v3,
            v7,
            v8,
            v9
          ]
        }
      ]
    }
  ]
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "MpTemplatePlaylistContainer_RefetchQuery",
  "id": null,
  "text": "query MpTemplatePlaylistContainer_RefetchQuery(\n  $query: String!\n  $playlist_id: ID!\n) {\n  node(id: $playlist_id) {\n    __typename\n    ...MpTemplatePlaylistContainer_node_1Qr5xf\n    id\n  }\n}\n\nfragment MpTemplatePlaylistContainer_node_1Qr5xf on MpTemplatePlaylist {\n  id\n  title\n  description\n  max_length\n  position\n  thumbnail(width: 240, height: 240) {\n    url\n    width\n    height\n    id\n  }\n  playlist_recommendations {\n    edges {\n      node {\n        id\n        title\n        description\n        thumbnail(width: 240, height: 240) {\n          url\n          width\n          height\n          id\n        }\n        num_songs\n      }\n    }\n  }\n  playlist_songs: mp_template_playlist_songs(first: 99999) {\n    edges {\n      node {\n        id\n        position\n        song {\n          __typename\n          id\n          isrc\n          name\n          album\n          artist\n          song_images {\n            edges {\n              node {\n                id\n                url\n                width\n                height\n              }\n            }\n          }\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  song_search(first: 10, query: $query) {\n    edges {\n      node {\n        __typename\n        id\n        name\n        album\n        artist\n        isrc\n        duration_ms\n        song_images {\n          edges {\n            node {\n              id\n              url\n              width\n              height\n            }\n          }\n        }\n        ... on SpotifySong {\n          external_id\n          external_source\n          external_data\n        }\n      }\n    }\n  }\n  mp_template {\n    can_edit\n    public\n    id\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "MpTemplatePlaylistContainer_RefetchQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": v1,
        "concreteType": null,
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "MpTemplatePlaylistContainer_node",
            "args": [
              {
                "kind": "Variable",
                "name": "query",
                "variableName": "query",
                "type": null
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "MpTemplatePlaylistContainer_RefetchQuery",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": v1,
        "concreteType": null,
        "plural": false,
        "selections": [
          v2,
          v3,
          {
            "kind": "InlineFragment",
            "type": "MpTemplatePlaylist",
            "selections": [
              v4,
              v5,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "max_length",
                "args": null,
                "storageKey": null
              },
              v6,
              v10,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "playlist_recommendations",
                "storageKey": null,
                "args": null,
                "concreteType": "PlaylistConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "PlaylistEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Playlist",
                        "plural": false,
                        "selections": [
                          v3,
                          v4,
                          v5,
                          v10,
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "num_songs",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": "playlist_songs",
                "name": "mp_template_playlist_songs",
                "storageKey": "mp_template_playlist_songs(first:99999)",
                "args": v11,
                "concreteType": "MpTemplatePlaylistSongConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "MpTemplatePlaylistSongEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "MpTemplatePlaylistSong",
                        "plural": false,
                        "selections": [
                          v3,
                          v6,
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "song",
                            "storageKey": null,
                            "args": null,
                            "concreteType": null,
                            "plural": false,
                            "selections": [
                              v2,
                              v3,
                              v12,
                              v13,
                              v14,
                              v15,
                              v16
                            ]
                          },
                          v2
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "cursor",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "pageInfo",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "endCursor",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "hasNextPage",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedHandle",
                "alias": "playlist_songs",
                "name": "mp_template_playlist_songs",
                "args": v11,
                "handle": "connection",
                "key": "MpTemplateContainer_mp_template_playlist_songs",
                "filters": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "song_search",
                "storageKey": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 10,
                    "type": "Int"
                  },
                  {
                    "kind": "Variable",
                    "name": "query",
                    "variableName": "query",
                    "type": "String!"
                  }
                ],
                "concreteType": "SongConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "SongEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": null,
                        "plural": false,
                        "selections": [
                          v2,
                          v3,
                          v13,
                          v14,
                          v15,
                          v12,
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "duration_ms",
                            "args": null,
                            "storageKey": null
                          },
                          v16,
                          {
                            "kind": "InlineFragment",
                            "type": "SpotifySong",
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "external_id",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "external_source",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "external_data",
                                "args": null,
                                "storageKey": null
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "mp_template",
                "storageKey": null,
                "args": null,
                "concreteType": "MpTemplate",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "can_edit",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "public",
                    "args": null,
                    "storageKey": null
                  },
                  v3
                ]
              }
            ]
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '8c88a511ff75ccea99452b7674f84686';
module.exports = node;



// WEBPACK FOOTER //
// ./webpack/components/Document/Template/MusicPlanner/__generated__/MpTemplatePlaylistContainer_RefetchQuery.graphql.js